<template>
  <div class="app-shell">
    <Sidebar />

    <div class="main-area">
      <TopBar />

      <div class="page-content">
        <div class="page-head">
          <h1>Chat</h1>
          <p>Manage your chats here.</p>
        </div>

        <FilterBar />

        <div class="content-grid">
          <ChatListPanel
            :chats="chats"
            :activeChatId="activeChatId"
            @select-chat="selectChat"
          />

          <ChatWindow
            :chat="activeChat"
            :messages="messages"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

import Sidebar from "@/components/AppSidebarr.vue";
import TopBar from "@/components/AppTopBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ChatListPanel from "@/components/ChatListPanel.vue";
import ChatWindow from "@/components/ChatWindow.vue";

const chats = ref([
  {
    id: 1,
    name: "John Doe",
    initials: "PG",
    message:
      "As a translator, I want integrate Crowdin webhook to notify translators about changed strings",
    replies: 2,
    time: "Aug 12 | 11:00 AM",
    status: "open",
  },
  {
    id: 2,
    name: "John Doe",
    initials: "PG",
    message:
      "As a translator, I want integrate Crowdin webhook to notify translators about changed strings",
    replies: 2,
    time: "Aug 12 | 11:00 AM",
    status: "queued",
  },
  {
    id: 3,
    name: "John Doe",
    initials: "PG",
    message:
      "As a translator, I want integrate Crowdin webhook to notify translators about changed strings",
    replies: 2,
    time: "Aug 12 | 11:00 AM",
    status: "closed",
  },
  {
    id: 4,
    name: "John Doe",
    initials: "PG",
    message:
      "As a translator, I want integrate Crowdin webhook to notify translators about changed strings",
    replies: 2,
    time: "Aug 12 | 11:00 AM",
    status: "open",
  },
]);

const activeChatId = ref(1);

const activeChat = computed(() =>
  chats.value.find((c) => c.id === activeChatId.value)
);

const messages = ref([
  {
    id: 1,
    sender: "user",
    name: "John Doe",
    text: "As a translator, I want integrate Crowdin webhook to notify translators about changed strings",
    time: "Aug 12 | 11:00 AM",
  },
  {
    id: 2,
    sender: "me",
    name: "Me",
    text: "As a translator, I want integrate Crowdin webhook to notify translators about changed strings",
    time: "Aug 12 | 11:00 AM",
  },
]);

function selectChat(id) {
  activeChatId.value = id;
}
</script>

<style scoped>
.app-shell {
  display: flex;
  height: 100vh;
  background: #f5f7fb;
  color: #1e293b;
  font-family: Arial, sans-serif;
}

.main-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page-content {
  padding: 18px;
  overflow: auto;
}

.page-head {
  margin-bottom: 14px;
}

.page-head h1 {
  margin: 0;
  font-size: 34px;
  font-weight: 700;
}

.page-head p {
  margin: 6px 0 0;
  color: #4b5563;
  font-size: 15px;
}

.content-grid {
  margin-top: 16px;
  display: grid;
  grid-template-columns: 420px 1fr;
  gap: 18px;
  height: calc(100vh - 190px);
}

@media (max-width: 1100px) {
  .content-grid {
    grid-template-columns: 1fr;
    height: auto;
  }
}
</style>